module.exports = __webpack_public_path__ + "img/logo_cars-4-sale.3507cf63.svg";